import { useEffect, type MutableRefObject } from 'react';

import { isAntdOverlayOpen } from '../utils/isAntdOverlayOpen';

interface UseCloseOnAntdOverlayParams {
  isOpenRef: MutableRefObject<boolean>;
  close: () => void;
}

/**
 * Closes SecondaryPanel when an Ant Design Drawer or Modal opens.
 */
export const useCloseOnAntdOverlay = ({
  isOpenRef,
  close,
}: UseCloseOnAntdOverlayParams): void => {
  useEffect(() => {
    const maybeClose = () => {
      if (!isOpenRef.current) {
        return;
      }

      if (isAntdOverlayOpen()) {
        close();
      }
    };

    maybeClose();

    const observer = new MutationObserver(maybeClose);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    return () => {
      observer.disconnect();
    };
  }, [close, isOpenRef]);
};
